import React, { useContext, useState } from "react";
import { useTranslation } from 'react-i18next';

import "./modern-style.css";
import "../../../styles/page-titles.css";

import { MdLockOpen, MdLockOutline } from "react-icons/md";
import { TbClockHour4 } from "react-icons/tb";
import { FiInfo, FiClock, FiAlertCircle } from "react-icons/fi";
import { IoWalletOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

import { ModalOpenCaixa } from "../../../components/ModalOpenCaixa";
import { AuthContext } from "../../../contexts/auth";
import { registerCaixaAndOpen, syncEmpresaFlags } from "../../../services/api";
import { convertPrice } from "../../../utils/convertPrice";
import { CaixaContext } from "../../../contexts/caixaContext";
import { SidebarContext } from "../../../AppRoutes"
import styled from "styled-components";

const ContainerCaixa = styled.div`
  width: auto;
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${({ sidebar }) => (sidebar ? '250px' : '100px')};
  padding: 24px;
  transition: margin-left 200ms ease;

  @media (max-width: 880px) {
    margin-left: 0;
    padding: 24px 16px;
  }
`

function ClosedCaixa() {
  const { t } = useTranslation('cashRegister');
  const { user } = useContext(AuthContext);

  const empresa = localStorage.getItem('empresa')
  const empresaParse = JSON.parse(empresa)
  const idEmpresa = empresaParse.id_empresa;

  const { sidebar } = useContext(SidebarContext);
  const { caixa, refetch, refetchStatus } = useContext(CaixaContext);

  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const onOpen = () => {
    setIsOpen(true);
  };
  const onClose = () => {
    setIsOpen(false);
  };

  const handleOpenCaixa = async ({ amount }) => {
    try {
      // Primeira tentativa de abrir caixa
      const response = await registerCaixaAndOpen(
        user._id,
        idEmpresa,
        convertPrice(amount)
      );
      refetchStatus();
      refetch();
      return response;
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao abrir caixa:', error);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Status do erro:', error.response?.status);
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Mensagem do erro:', error.response?.data?.msg);

      // Se erro for de caixa já aberto, tenta sincronizar e tentar novamente
      const errorMessage = error.response?.data?.msg || error.message || '';
      const isCaixaOpenError = errorMessage.toLowerCase().includes('já existe um caixa aberto') ||
                              errorMessage.toLowerCase().includes('caixa aberto');

      if (error.response?.status === 400 && isCaixaOpenError) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Detectado conflito de caixa - Tentando sincronização...', errorMessage);

        try {
          // Sincronizar flags da empresa
          await syncEmpresaFlags();
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Sincronização concluída - Recarregando página...');

          // Forçar reload da página para garantir que o estado seja atualizado
          setTimeout(() => {
            window.location.reload();
          }, 1000);

          throw new Error(t('closed.inconsistencyFixed'));

        } catch (syncError) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro na sincronização:', syncError);

          // Se erro na sincronização, ainda assim tenta reload
          if (syncError.message !== t('closed.inconsistencyFixed')) {
            setTimeout(() => {
              window.location.reload();
            }, 2000);
            throw new Error(t('closed.syncError'));
          }
          throw syncError;
        }
      }

      throw error; // Re-throw para que o ModalOpenCaixa possa capturar
    }
  };

  return (
    <>
      <ContainerCaixa sidebar={sidebar}>
        <div className="modern-closed-container">
          <div className="modern-closed-content">
          {/* Action Buttons */}
          <div className="modern-closed-actions">
            <button
              className="modern-closed-btn modern-closed-btn-primary"
              onClick={onOpen}
            >
              <MdLockOpen />
              {t('closed.openRegister')}
            </button>
            <button
              className="modern-closed-btn modern-closed-btn-secondary"
              onClick={() => navigate("/caixa/historico")}
            >
              <TbClockHour4 />
              {t('closed.historyButton')}
            </button>
          </div>

          {/* Main Info Card */}
          <div className="modern-closed-card">
            <div className="modern-closed-header">
              <div className="modern-closed-icon">
                <IoWalletOutline />
              </div>
              <div className="modern-closed-title">
                {t('closed.title')}
                <span className="modern-closed-status">
                  <MdLockOutline />
                  {t('closed.inactive')}
                </span>
              </div>
            </div>

            <div className="modern-closed-info">
              <div className="modern-info-item">
                <FiInfo className="modern-info-icon" />
                <div className="modern-info-content">
                  <p className="modern-info-text">
                    <span className="modern-info-highlight">{t('closed.infoAutoEntries')}</span> {t('closed.infoAutoEntriesDesc')}
                  </p>
                </div>
              </div>

              <div className="modern-info-item">
                <FiClock className="modern-info-icon" />
                <div className="modern-info-content">
                  <p className="modern-info-text">
                    <span className="modern-info-highlight">{t('closed.infoTrackTransactions')}</span> {t('closed.infoTrackTransactionsDesc')}
                  </p>
                </div>
              </div>

              <div className="modern-info-item">
                <FiAlertCircle className="modern-info-icon" />
                <div className="modern-info-content">
                  <p className="modern-info-text">
                    <span className="modern-info-highlight">{t('closed.infoCheckValues')}</span> {t('closed.infoCheckValuesDesc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </ContainerCaixa>
      <ModalOpenCaixa
        isOpen={isOpen}
        onClose={onClose}
        initialPrice={caixa.saldo_final}
        handleOpen={handleOpenCaixa}
        refetch={() => {
          refetchStatus(); // Atualiza status da empresa
          refetch(); // Atualiza dados do caixa
        }}
      />
    </>
  );
}

export default ClosedCaixa;
